const closeButtonLabel = "Fechar";
const ptPT = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  ptPT as default
};
